import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRutter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 46 46",
	fill: "currentColor",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M31.2578 43.0914C31.2578 44.4454 30.1602 45.543 28.8062 45.543L12.6481 45.543C5.66281 45.543 0.000134009 39.8803 0.00013462 32.895L0.000136033 16.7369C0.000136151 15.3829 1.09775 14.2853 2.45172 14.2853L8.85647 14.2853L8.85647 19.1885L4.9033 19.1885L4.9033 32.895C4.9033 37.1723 8.37075 40.6398 12.6481 40.6398L26.3546 40.6398L26.3546 16.7369C26.3546 15.3829 27.4523 14.2853 28.8062 14.2853C30.1602 14.2853 31.2578 15.3829 31.2578 16.7369L31.2578 43.0914Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.0977 2.64006C14.0977 1.28609 15.1953 0.188477 16.5492 0.188477H32.7074C39.6927 0.188477 45.3553 5.85115 45.3553 12.8364V28.9946C45.3553 30.3485 44.2577 31.4462 42.9038 31.4462H36.499V26.543H40.4522V12.8364C40.4522 8.55909 36.9847 5.09164 32.7074 5.09164H19.0008V28.9946C19.0008 30.3485 17.9032 31.4462 16.5492 31.4462C15.1953 31.4462 14.0977 30.3485 14.0977 28.9946V2.64006Z"
	})]
});
export default SvgRutter;
